import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createHistory } from 'history';
import { Router, useRouterHistory, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { appRoutes, recipientRoutes } from './routes';
import configureStore from './store/configureStore';
////not delete
import requireAllImages from './images/required.js';

import './styles/telephoneInputStyles.css';
import './styles/styles.scss'; // Yep, that's right. You can import SASS/CSS files too! Webpack will run the associated loader and plug this into the page.
require("babel-polyfill");


const store = configureStore();
const history = syncHistoryWithStore(browserHistory, store);
const historyForRecipient = useRouterHistory(createHistory)({
  basename: '/#'
});

function isRecipient(url) {
  if (url.indexOf('recipient') !== -1) {
    localStorage.setItem('isRecipient', 1);
    return true;
  }
  else
    return false;
}

render(
  <Provider store={store}>
    <Router
      history={!isRecipient(document.location.href) ? history : historyForRecipient}
      routes={!isRecipient(document.location.href) ? appRoutes : recipientRoutes} />
  </Provider>, document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js